import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { SearchIcon, SeatIcon, CheckIcon, DownloadIcon } from "@/components/Icons";

const steps = [
    { icon: SearchIcon, title: "Search", body: "Filter test centers by city, exam and date. See amenities & real photos." },
    { icon: SeatIcon, title: "Pick a seat", body: "Choose an exact desk from a live seat map. First come, first booked." },
    { icon: CheckIcon, title: "Pay & confirm", body: "Secure Stripe checkout. Your seat is locked the moment payment clears." },
    { icon: DownloadIcon, title: "Download admit card", body: "Get a PDF with your unique code and QR — carry it to the center." },
];

export default function HowItWorks() {
    return (
        <div className="mx-auto max-w-6xl px-6 py-16">
            <div className="overline mb-3">How it works</div>
            <h1 className="font-heading text-5xl font-black tracking-tight">Four steps between you and a real exam room.</h1>

            <div className="mt-14 grid md:grid-cols-4 gap-6">
                {steps.map(({ icon: I, title, body }, i) => (
                    <div key={title} className="border border-border p-6 bg-card">
                        <div className="overline">Step {String(i + 1).padStart(2, "0")}</div>
                        <I className="h-8 w-8 text-primary mt-4" />
                        <div className="font-heading text-xl font-bold mt-6">{title}</div>
                        <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{body}</p>
                    </div>
                ))}
            </div>

            <div className="mt-16 border border-border p-10 bg-card">
                <h2 className="font-heading text-3xl font-bold tracking-tight">Ready to sit for the real thing?</h2>
                <div className="mt-6 flex gap-3">
                    <Link to="/centers"><Button className="rounded-sm bg-primary hover:bg-primary/90">Find a center</Button></Link>
                    <Link to="/register?role=owner"><Button variant="outline" className="rounded-sm">List your center</Button></Link>
                </div>
            </div>
        </div>
    );
}
